import { useCallback, useEffect } from 'react';
export const useClickOutside = (refs, handler, ev = true) => {
    const handleClickOutside = useCallback((event) => {
        refs.length > 0 &&
            refs.forEach((ref) => {
                if (ref && !ref?.contains(event.target)) {
                    handler(event);
                }
                if (ref?.current && !ref?.current.contains(event.target)) {
                    handler(event);
                }
            });
    }, [handler, refs]);
    useEffect(() => {
        document.addEventListener('click', handleClickOutside, ev);
        return () => {
            document.removeEventListener('click', handleClickOutside, ev);
        };
    }, [ev, handleClickOutside, handler, refs]);
};
//# sourceMappingURL=useClickOutside.js.map